<template>
    <div class="animated slideInRight">
        <div class="row text-center">
            <div class="col">
                <div class="">
                    <div class="animated rubberBand slow delay-1s">
                        <div class="icon">
                            <i class="fa fa-check text-info display-1"></i>
                        </div>
                    </div>
                    <p class="blockquote">You have booked a pick up for {{state.items.length}} item(s).</p>
                    <p class="blockquote">Going from <strong>{{this.state.consignmentData.sender_town}}</strong> to <strong>{{this.state.consignmentData.receiver_town}}</strong>.</p>
                    <p class="blockquote">Freight pick up requested on {{formattedDate}}.</p>
                    <div class="row mt-5">
                        <div class="col">
                            <button class="btn btn-primary float-right" v-on:click="goToRoot">Book Another Pickup?</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Step from '@/mixins/step'
    export default {
        mixins: [ Step ],
        name: 'StepComplete',
        props: [],
        data () {
            return {}
        },
        filters: {},
        computed: {
            formattedDate: function () {
                return this.$moment(this.state.combinedDateTime).format('dddd, MMMM Do YYYY [at] h:mma z')
            }
        },
        methods: {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .icon {
        font-size: 7rem;
    }
</style>
